import React from 'react';

import DateRangesDropdown from '../../base/dropdowns/dateranges-dropdown';
import PartnerDropdown from '../../base/dropdowns/partner-dropdown';
import MerchantCarousel from './merchant-carousel';
import TrendTotals from './trend-totals';

const InsightsPanel = ({
  merchants,
  data,
  updateDateRange,
  updateMerchants,
  insightsType,
  eventPrefix,
  resetCarousel,
}) => {
  const keyword = insightsType === 'cart-explorer' ? 'buying' : 'searching';
  const dateRangeItems = [
    { label: 'Last 24 Hours', name: 'twentyFourHour', unit: 'hour', selected: true },
    { label: 'Last 30 Days', name: 'thirtyDay', unit: 'day', selected: false },
  ];

  const dateRange =
    insightsType === 'cart-explorer' ? (
      <DateRangesDropdown
        gaEvent={{
          category: eventPrefix,
          label: 'Date Picker Dropdown',
        }}
        items={dateRangeItems}
        updateRange={updatedItems => updateDateRange(updatedItems)}
      />
    ) : (
      <div className="granularity">Last 30 days</div>
    );

  const headerTxt =
    insightsType !== 'product-research'
      ? `Explore what millions of people are ${keyword}`
      : 'Product Research';

  const dropdownContainer =
    insightsType !== 'product-research' ? (
      <div className="dropdown-container">
        <PartnerDropdown
          gaEvent={{
            category: eventPrefix,
            label: `Merchant Picker Dropdown`,
          }}
          statType="insights"
          items={merchants}
          updatePartners={updateMerchants}
          staticFields={[]}
        />
        {dateRange}
      </div>
    ) : null;

  const merchantCarousel =
    insightsType !== 'product-research' ? (
      <MerchantCarousel
        insightsType={insightsType}
        merchants={merchants}
        updateMerchants={updateMerchants}
        resetCarousel={resetCarousel}
      />
    ) : null;

  return (
    <div className="insights-panel">
      <div className="header">
        <h2>{headerTxt}</h2>
        <TrendTotals type={insightsType} data={data} />
        {dropdownContainer}
      </div>
      {merchantCarousel}
    </div>
  );
};

export default InsightsPanel;
